import { useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import PatternCard from '../PatternCard/PatternCard';

import { visualizerActions } from '../../store';

import styles from './PatternList.module.css';
import { uiActions } from '../../store';
import { SvgHelper } from '../../Helpers/SvgHelper';


const PatternList = () => {
    const patternData = useSelector((state) => state.visualizer.patternData);
    const dispatch = useDispatch();
    const appliedFilters = useSelector(state => state.visualizer.appliedFilters);
    const navigate = useNavigate();
    
    let types = [];
    let sizes = [];
    let patternNames = [];

    // loops through data from appliedFilters array and pushes the values to individual arrays based on the key
    appliedFilters.forEach(f => {
        if(f["name"] === "type"){
            if(f["value"] !== 'all' && f["value"] != '-1')
                types.push(f["value"])
        } 
        if(f["name"] === "tileSizes"){
            if(f["value"] !== 'all' && f["value"] != '-1')
                sizes.push(f["value"].replace(/['" ]/g, ''))
        } 
        if(f["name"] === "patternType"){
            if(f["value"] !== 'all' && f["value"] != '-1')
                patternNames.push(f["value"])
        } 
    });

    
    const handlePatternSelect = (pattern) => {
        const patternName = pattern.name || pattern.patternName || '';
        // Find all patterns with the same name
        const matchingPatterns = patternData.filter(p => 
            (p.name || p.patternName || '') === patternName
        );
        
        dispatch(visualizerActions.setActivePattern(pattern));
        dispatch(visualizerActions.setMatchingPatterns(matchingPatterns));
        dispatch(uiActions.setPatternSizeSelectorModalActive(true));
    };

    //determines if a pattern should be shown based on if the pattern attribues are found in the relative array
    //example: sizes = [1x1,2x2] only patterns that are 1x1 or 2x2 would show.
    const shouldShow = (pattern) => {
        // Handle new JSON structure - patterns may not have all the old fields
        const tileSizes = pattern.tileSizes ? pattern.tileSizes.split(',').map(str => str.replace(/['" ]/g, '')) : [];
        return (
            (!sizes.length || sizes.every(item => tileSizes.includes(item))) &&
            (!types.length || types.includes(pattern.type)) &&
            (!patternNames.length || patternNames.includes(pattern.patternType)) &&
            (pattern.active === undefined || pattern.active === 1)
        );
    };
    
    
    // Filter out duplicates by pattern name
    const uniquePatterns = patternData
        .filter(shouldShow)
        .reduce((acc, pattern) => {
            const patternName = pattern.name || pattern.patternName || '';
            if (!acc.some(p => (p.name || p.patternName || '') === patternName)) {
                acc.push(pattern);
            }
            return acc;
        }, []);

    const patternCards = uniquePatterns
    .sort((a, b) => {
        const aType = a.patternType || '';
        const bType = b.patternType || '';
        const primary = aType.toLowerCase().localeCompare(bType.toLowerCase(), 'en', { sensitivity: 'base' });
        if (primary !== 0) return primary;
        return (a.id || 0) - (b.id || 0);
    })
    .map((pattern, index) => (
        <PatternCard
        key={`${pattern.id || pattern.name}-${index}`}
        pattern={pattern}
        onSelect={() => handlePatternSelect(pattern)} 
        />
    ));

    return (
        <div className={styles.content}>
            {patternCards}
        </div>
    );
};

export default PatternList;
